import { useEvents, type EventListItem } from '@/hooks/useEvents';

/**
 * useConcertBackdrop — devuelve la MISMA imagen de fondo que usan los heroes de
 * Home / Eventos / Membresías: la portada más repetida del catálogo real de
 * eventos (en el seed, una escena de público en concierto SIN branding de
 * terceros). Reusa `useEvents()` (read-only, cacheado por TanStack Query, así
 * que no dispara fetch extra si otra vista ya lo cargó). Sin portadas → `null`,
 * y el `PageBanner` cae a su look de solo-gradientes.
 *
 * Extraído para no duplicar el picker en cada página (antes vivía como copia
 * local `pickEventBackdrop`/`pickConcertBackdrop` en Eventos y Membresías).
 */
export function pickConcertBackdrop(events: ReadonlyArray<EventListItem>): string | null {
  const counts = new Map<string, number>();
  for (const e of events) {
    if (e.coverImage) counts.set(e.coverImage, (counts.get(e.coverImage) ?? 0) + 1);
  }
  let best: string | null = null;
  let bestCount = 0;
  for (const [url, n] of counts) {
    if (n > bestCount) {
      best = url;
      bestCount = n;
    }
  }
  return best;
}

export function useConcertBackdrop(): string | null {
  const { data: events } = useEvents();
  return pickConcertBackdrop(events ?? []);
}
